import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type CrowdstrikeConnectorConfig = typeof CrowdstrikeConnector._.Config;

export const CrowdstrikeConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Crowdstrike,
  logoPath: 'images/crowdstrike-logo.svg',
  categories: [IntegrationConnectorCategory.Security, IntegrationConnectorCategory.Endpoint],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.ApiClient,
      configSchema: z.object({
        baseUrl: z.url(),
        clientId: z.string().min(1),
      }),
      encryptedConfigSchema: z.object({
        clientSecret: z.string().min(1),
      }),
    }),
  ]),
});
